<rds-header-link
  [routerLink]="'/dashboard/favorites'"
  size="l"
  routerLinkActive="rds-link--active">
  <rds-icon
    namespace="outlined"
    icon="heart"
    rdsBadge
    [rdsBadgeLabel]="favoriteCount()"
    [rdsBadgeColor]="'neutral'"></rds-icon>
</rds-header-link>
